export default "__VITE_ASSET__Jd2PUc8b__"